import React from "react";
import SideNav from "./SideNav/SideNav";
import Navbar from "./Navbar/Navbar";
import { useSidebar } from "../context/SidebarContext";

const FixedComponents = () => {
  const { isMobile, isCollapsed, toggleSidebar } = useSidebar();

  return (
    <div>
      <Navbar isMobile={isMobile} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
      <SideNav
        isMobile={isMobile}
        isCollapsed={isCollapsed}
        toggleSidebar={toggleSidebar}
      />
    </div>
  );
};

export default FixedComponents;
